/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventManagementCreateEventItemRequest } from './EventManagementCreateEventItemRequest';

export type EventManagementCreateEventRequest = {
    title: string;
    titleEn?: string | null;
    titleCn?: string | null;
    startDatetime: string;
    endDatetime: string;
    isPreEntry: boolean;
    preEntryEndTime?: string | null;
    thumbnailNo?: number | null;
    isUploadThumbnails: boolean;
    imageId?: number | null;
    context: string;
    contextEn?: string | null;
    contextCn?: string | null;
    postDate?: string | null;
    openStatus: EventManagementCreateEventRequest.openStatus;
    releaseSetting?: EventManagementCreateEventRequest.releaseSetting;
    eventItems?: Array<EventManagementCreateEventItemRequest>;
};

export namespace EventManagementCreateEventRequest {

    export enum openStatus {
        EDIT = 'edit',
        RELEASE = 'release',
        CANCEL = 'cancel',
    }

    export enum releaseSetting {
        NOW = 'now',
        DATE = 'date',
    }


}

